export const theplagueNFTs = [
               
        {
            id: 'The Plague NFT-10997',
            name: 'The Plague #10997',
            image: 'https://ipfs.io/ipfs/QmV3XwQg4r6tPW7ReBze4iWUcqFeezsY6bMW1aUdPXJPNF',
            price: '0.32 ETH'
        },
        {
            id: 'The Plague NFT-10999',
            name: 'The Plague #10999',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10999.png',
            price: '0.67 ETH'
        },
        {
            id: 'The Plague NFT-10998',
            name: 'The Plague #10998',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10998.png',
            price: '0.28 ETH'
        },
        {
            id: 'The Plague NFT-10995',
            name: 'The Plague #10995',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10995.png',
            price: '0.55 ETH'
        },
        {
            id: 'The Plague NFT-10996',
            name: 'The Plague #10996',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10996.png',
            price: '0.41 ETH'
        },
        {
            id: 'The Plague NFT-10994',
            name: 'The Plague #10994',
            image: 'https://ipfs.io/ipfs/QmS8XFCF4NNbr1ELJ7dArt3L44zVgbiS6qLYBY7GEfbJUz',
            price: '0.73 ETH'
        },
        {
            id: 'The Plague NFT-10993',
            name: 'The Plague #10993',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10993.png',
            price: '0.25 ETH'
        },
        {
            id: 'The Plague NFT-10992',
            name: 'The Plague #10992',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10992.png',
            price: '0.62 ETH'
        },
        {
            id: 'The Plague NFT-10990',
            name: 'The Plague #10990',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10990.png',
            price: '0.38 ETH'
        },
        {
            id: 'The Plague NFT-10991',
            name: 'The Plague #10991',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10991.png',
            price: '0.79 ETH'
        },
        {
            id: 'The Plague NFT-10989',
            name: 'The Plague #10989',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10989.png',
            price: '0.22 ETH'
        },
        {
            id: 'The Plague NFT-10988',
            name: 'The Plague #10988',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10988.png',
            price: '0.58 ETH'
        },
        {
            id: 'The Plague NFT-10987',
            name: 'The Plague #10987',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10987.png',
            price: '0.35 ETH'
        },
        {
            id: 'The Plague NFT-10986',
            name: 'The Plague #10986',
            image: 'https://ipfs.io/ipfs/QmR2K5HLMYAaGHbbF7ij9rQb9wqsH8vUwSfiZD5xRFj6UQ',
            price: '0.71 ETH'
        },
        {
            id: 'The Plague NFT-10985',
            name: 'The Plague #10985',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10985.png',
            price: '0.19 ETH'
        },
        {
            id: 'The Plague NFT-10984',
            name: 'The Plague #10984',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10984.png',
            price: '0.52 ETH'
        },
        {
            id: 'The Plague NFT-10981',
            name: 'The Plague #10981',
            image: 'https://ipfs.io/ipfs/QmYCYVasJxa4eTsNbdTAZQ1BBisLRBb3id7GWp9xfHfm34',
            price: '0.33 ETH'
        },
        {
            id: 'The Plague NFT-10983',
            name: 'The Plague #10983',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10983.png',
            price: '0.68 ETH'
        },
        {
            id: 'The Plague NFT-10982',
            name: 'The Plague #10982',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10982.png',
            price: '0.42 ETH'
        },
        {
            id: 'The Plague NFT-10980',
            name: 'The Plague #10980',
            image: 'https://ipfs.io/ipfs/QmabkmLa9pJ2Ew2YTQjuqSzbQRQwDrdHeRnfwanF16kpxP',
            price: '0.77 ETH'
        },
        {
            id: 'The Plague NFT-10979',
            name: 'The Plague #10979',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10979.png',
            price: '0.155 ETH'
        },
        {
            id: 'The Plague NFT-10978',
            name: 'The Plague #10978',
            image: 'https://ipfs.io/ipfs/QmcMmrZJkbYpxCj4K1PHCF2UVDpZbvHcHF5jGatqC1LUM2',
            price: '0.48 ETH'
        },
        {
            id: 'The Plague NFT-10977',
            name: 'The Plague #10977',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10977.png',
            price: '0.31 ETH'
        },
        {
            id: 'The Plague NFT-10976',
            name: 'The Plague #10976',
            image: 'https://ipfs.io/ipfs/Qmaq5tk1KhbqMLjZb9GiQaz94ofn4yJ3yhko6pAUgB38rM',
            price: '0.65 ETH'
        },
        {
            id: 'The Plague NFT-10975',
            name: 'The Plague #10975',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10975.png',
            price: '0.39 ETH'
        },
        {
            id: 'The Plague NFT-10973',
            name: 'The Plague #10973',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10973.png',
            price: '0.74 ETH'
        },
        {
            id: 'The Plague NFT-10974',
            name: 'The Plague #10974',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10974.png',
            price: '0.27 ETH'
        },
        {
            id: 'The Plague NFT-10972',
            name: 'The Plague #10972',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10972.png',
            price: '0.61 ETH'
        },
        {
            id: 'The Plague NFT-10971',
            name: 'The Plague #10971',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10971.png',
            price: '0.36 ETH'
        },
        {
            id: 'The Plague NFT-10969',
            name: 'The Plague #10969',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10969.png',
            price: '0.72 ETH'
        },
        {
            id: 'The Plague NFT-10970',
            name: 'The Plague #10970',
            image: 'https://ipfs.io/ipfs/QmYyyNE73XQW7qVEAVgj1hsxjEvE5sKn6srx9hsZQdqdu9',
            price: '0.24 ETH'
        },
        {
            id: 'The Plague NFT-10967',
            name: 'The Plague #10967',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10967.png',
            price: '0.57 ETH'
        },
        {
            id: 'The Plague NFT-10968',
            name: 'The Plague #10968',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10968.png',
            price: '0.34 ETH'
        },
        {
            id: 'The Plague NFT-10966',
            name: 'The Plague #10966',
            image: 'https://ipfs.io/ipfs/QmWJ7ayJyqS6wrWWh4pXqkt1M78Sah9f9MEysKeHfUKQB8',
            price: '0.69 ETH'
        },
        {
            id: 'The Plague NFT-10965',
            name: 'The Plague #10965',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10965.png',
            price: '0.21 ETH'
        },
        {
            id: 'The Plague NFT-10964',
            name: 'The Plague #10964',
            image: 'https://ipfs.io/ipfs/QmTc7iP1GtqQmkG5cTK9YRgRaWxZ17W8annjWjXyR6i2y3',
            price: '0.54 ETH'
        },
        {
            id: 'The Plague NFT-10963',
            name: 'The Plague #10963',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10963.png',
            price: '0.31 ETH'
        },
        {
            id: 'The Plague NFT-10962',
            name: 'The Plague #10962',
            image: 'https://ipfs.io/ipfs/QmXxAPsXTcC5m1PznF86oGH36enXG6Ld8GYrJ94BCY1ShE',
            price: '0.66 ETH'
        },
        {
            id: 'The Plague NFT-10961',
            name: 'The Plague #10961',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10961.png',
            price: '0.43 ETH'
        },
        {
            id: 'The Plague NFT-10960',
            name: 'The Plague #10960',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10960.png',
            price: '0.75 ETH'
        },
        {
            id: 'The Plague NFT-10959',
            name: 'The Plague #10959',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10959.png',
            price: '0.29 ETH'
        },
        {
            id: 'The Plague NFT-10958',
            name: 'The Plague #10958',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10958.png',
            price: '0.63 ETH'
        },
        {
            id: 'The Plague NFT-10957',
            name: 'The Plague #10957',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10957.png',
            price: '0.37 ETH'
        },
        {
            id: 'The Plague NFT-10956',
            name: 'The Plague #10956',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10956.png',
            price: '0.70 ETH'
        },
        {
            id: 'The Plague NFT-10955',
            name: 'The Plague #10955',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10955.png',
            price: '0.26 ETH'
        },
        {
            id: 'The Plague NFT-10954',
            name: 'The Plague #10954',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10954.png',
            price: '0.59 ETH'
        },
        {
            id: 'The Plague NFT-10953',
            name: 'The Plague #10953',
            image: 'https://ipfs.io/ipfs/QmZNL83Ma1CDcvE2NEpMJ9M6PZgqH5ZwCuXee6LxvkRdKX',
            price: '0.34 ETH'
        },
        {
            id: 'The Plague NFT-10952',
            name: 'The Plague #10952',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10952.png',
            price: '0.67 ETH'
        },
        {
            id: 'The Plague NFT-10951',
            name: 'The Plague #10951',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10951.png',
            price: '0.23 ETH'
        },
        {
            id: 'The Plague NFT-10950',
            name: 'The Plague #10950',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10950.png',
            price: '0.56 ETH'
        },
        {
            id: 'The Plague NFT-10949',
            name: 'The Plague #10949',
            image: 'https://ipfs.io/ipfs/QmUxBpdZVLyXmx1kWVEw1Fuy8382AvRZFUMotvDV1UHmQc',
            price: '0.32 ETH'
        },
        {
            id: 'The Plague NFT-10948',
            name: 'The Plague #10948',
            image: 'https://ipfs.io/ipfs/QmQdi8eVth1BdiM9SaktHtNCZ29np1GXr2VxxHRJP4ZBJH',
            price: '0.64 ETH'
        },
        {
            id: 'The Plague NFT-10946',
            name: 'The Plague #10946',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10946.png',
            price: '0.80 ETH'
        },
        {
            id: 'The Plague NFT-10947',
            name: 'The Plague #10947',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10947.png',
            price: '0.44 ETH'
        },
            {
            id: 'The Plague NFT-10945',
            name: 'The Plague #10945',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10945.png',
            price: '0.53 ETH'
        },
        {
            id: 'The Plague NFT-10944',
            name: 'The Plague #10944',
            image: 'https://ipfs.io/ipfs/QmU1ksNfyiy8e835ZSPgTkovWH4fjuHJNaWQfAJFPmU5Ep',
            price: '0.28 ETH'
        },
        {
            id: 'The Plague NFT-10943',
            name: 'The Plague #10943',
            image: 'https://ipfs.io/ipfs/QmWsY89nSXPnpkgtXWi5e3ZGMmsHj63HnrKDxMBYpsJEQz',
            price: '0.61 ETH'
        },
        {
            id: 'The Plague NFT-10941',
            name: 'The Plague #10941',
            image: 'https://ipfs.io/ipfs/QmRxT3bZwksN3yhajGTo5d9oa44e9BDrvfTChY4ZtuqKWY',
            price: '0.35 ETH'
        },
        {
            id: 'The Plague NFT-10942',
            name: 'The Plague #10942',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10942.png',
            price: '0.72 ETH'
        },
        {
            id: 'The Plague NFT-10940',
            name: 'The Plague #10940',
            image: 'https://ipfs.io/ipfs/QmTbbUQAahsbewyYxC6VdWyhke1uKZBGPRiMTqoBfM3gEW',
            price: '0.25 ETH'
        },
        {
            id: 'The Plague NFT-10939',
            name: 'The Plague #10939',
            image: 'https://ipfs.io/ipfs/Qmdm3MLsu74HnLKXTEF5t64ReFRU6qGAXPWpNqePYjyShg',
            price: '0.58 ETH'
        },
        {
            id: 'The Plague NFT-10937',
            name: 'The Plague #10937',
            image: 'https://ipfs.io/ipfs/QmSW3fbGQHpfff4yGosv93hMKSaDQTFAbnEQiEnSB6n5Ld',
            price: '0.33 ETH'
        },
        {
            id: 'The Plague NFT-10938',
            name: 'The Plague #10938',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10938.png',
            price: '0.69 ETH'
        },
        {
            id: 'The Plague NFT-10935',
            name: 'The Plague #10935',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10935.png',
            price: '0.22 ETH'
        },
        {
            id: 'The Plague NFT-10936',
            name: 'The Plague #10936',
            image: 'https://ipfs.io/ipfs/QmRyEdyQQ7BUs77DaYcQnMMKqEJbZ49ALPPEcJtZDuYnYi',
            price: '0.55 ETH'
        },
        {
            id: 'The Plague NFT-10934',
            name: 'The Plague #10934',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10934.png',
            price: '0.31 ETH'
        },
        {
            id: 'The Plague NFT-10933',
            name: 'The Plague #10933',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10933.png',
            price: '0.66 ETH'
        },
        {
            id: 'The Plague NFT-10932',
            name: 'The Plague #10932',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10932.png',
            price: '0.19 ETH'
        },
        {
            id: 'The Plague NFT-10931',
            name: 'The Plague #10931',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10931.png',
            price: '0.52 ETH'
        },
        {
            id: 'The Plague NFT-10930',
            name: 'The Plague #10930',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10930.png',
            price: '0.29 ETH'
        },
        {
            id: 'The Plague NFT-10927',
            name: 'The Plague #10927',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10927.png',
            price: '0.63 ETH'
        },
        {
            id: 'The Plague NFT-10928',
            name: 'The Plague #10928',
            image: 'https://ipfs.io/ipfs/Qmc9zuuSDhPc7G4Xqjwh4TBLo37hMv4LpVd9TXnfwMuAVs',
            price: '0.37 ETH'
        },
        {
            id: 'The Plague NFT-10929',
            name: 'The Plague #10929',
            image: 'https://ipfs.io/ipfs/QmSWrefvRdDQB4Hgq8RMqkEsWZdPSXs7AJPsRcyzxXvFtU',
            price: '0.74 ETH'
        },
        {
            id: 'The Plague NFT-10926',
            name: 'The Plague #10926',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10926.png',
            price: '0.26 ETH'
        },
        {
            id: 'The Plague NFT-10925',
            name: 'The Plague #10925',
            image: 'https://ipfs.io/ipfs/QmZngRduheXjY7B7DTqZCveYSHwJ3VExwjLN1rPZn3phQY',
            price: '0.59 ETH'
        },
        {
            id: 'The Plague NFT-10924',
            name: 'The Plague #10924',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10924.png',
            price: '0.34 ETH'
        },
        {
            id: 'The Plague NFT-10923',
            name: 'The Plague #10923',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10923.png',
            price: '0.67 ETH'
        },
        {
            id: 'The Plague NFT-10922',
            name: 'The Plague #10922',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10922.png',
            price: '0.23 ETH'
        },
        {
            id: 'The Plague NFT-10919',
            name: 'The Plague #10919',
            image: 'https://ipfs.io/ipfs/QmRViK9z6UHLUMncC5ycZb5BeXBLZhL1dSRM4LL9rVdoKX',
            price: '0.56 ETH'
        },
        {
            id: 'The Plague NFT-10921',
            name: 'The Plague #10921',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10921.png',
            price: '0.32 ETH'
        },
        {
            id: 'The Plague NFT-10920',
            name: 'The Plague #10920',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10920.png',
            price: '0.64 ETH'
        },
        {
            id: 'The Plague NFT-10918',
            name: 'The Plague #10918',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10918.png',
            price: '0.20 ETH'
        },
        {
            id: 'The Plague NFT-10917',
            name: 'The Plague #10917',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10917.png',
            price: '0.53 ETH'
        },
        {
            id: 'The Plague NFT-10916',
            name: 'The Plague #10916',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10916.png',
            price: '0.30 ETH'
        },
        {
            id: 'The Plague NFT-10915',
            name: 'The Plague #10915',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10915.png',
            price: '0.61 ETH'
        },
        {
            id: 'The Plague NFT-10913',
            name: 'The Plague #10913',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10913.png',
            price: '0.17 ETH'
        },
        {
            id: 'The Plague NFT-10911',
            name: 'The Plague #10911',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10911.png',
            price: '0.50 ETH'
        },
        {
            id: 'The Plague NFT-10912',
            name: 'The Plague #10912',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10912.png',
            price: '0.27 ETH'
        },
        {
            id: 'The Plague NFT-10914',
            name: 'The Plague #10914',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10914.png',
            price: '0.58 ETH'
        },
        {
            id: 'The Plague NFT-10910',
            name: 'The Plague #10910',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10910.png',
            price: '0.34 ETH'
        },
        {
            id: 'The Plague NFT-10909',
            name: 'The Plague #10909',
            image: 'https://ipfs.io/ipfs/QmcRm7F129d1Kt4wAuL6eeiXzg8sutRKe1SfobENURDZ85',
            price: '0.65 ETH'
        },
        {
            id: 'The Plague NFT-10908',
            name: 'The Plague #10908',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10908.png',
            price: '0.21 ETH'
        },
        {
            id: 'The Plague NFT-10907',
            name: 'The Plague #10907',
            image: 'https://ipfs.io/ipfs/QmbP5jXEveZv3D63UhHArSPZTYf9JBTcokJkehz5rzm7Kv',
            price: '0.55 ETH'
        },
        {
            id: 'The Plague NFT-10905',
            name: 'The Plague #10905',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10905.png',
            price: '0.31 ETH'
        },
        {
            id: 'The Plague NFT-10906',
            name: 'The Plague #10906',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10906.png',
            price: '0.62 ETH'
        },
        {
            id: 'The Plague NFT-10904',
            name: 'The Plague #10904',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10904.png',
            price: '0.18 ETH'
        },
        {
            id: 'The Plague NFT-10903',
            name: 'The Plague #10903',
            image: 'https://ipfs.io/ipfs/QmWAt8W9qjhd96nrRERvZmyLEtLoqWYw4moLuHtyWjVK5s',
            price: '0.52 ETH'
        },
        {
            id: 'The Plague NFT-10902',
            name: 'The Plague #10902',
            image: 'https://ipfs.io/ipfs/QmUummtU2338HS3XCtgGQr7SGNUCFZuphPscpEjKm6vJUt',
            price: '0.29 ETH'
        },
        {
            id: 'The Plague NFT-10901',
            name: 'The Plague #10901',
            image: 'https://ipfs.io/ipfs/QmQ6MDtfjg7LZbPRe7A3ZSPEtvYcVqUTmsuTMM1zhUR8MG/10901.png',
            price: '0.59 ETH'
        }
        
];